// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type PathwayAccessGroupsQueryVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  order?: PrivateSchemaTypes.Maybe<Array<PrivateSchemaTypes.OrderDescriptor> | PrivateSchemaTypes.OrderDescriptor>;
}>;


export type PathwayAccessGroupsQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { pathway?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'PathwayModelAsAdmin' }
      & Pick<PrivateSchemaTypes.PathwayModelAsAdmin, 'id'>
      & { groups: Array<(
        { __typename?: 'GroupModel' }
        & PathwayAccessGroupFragment
      )> }
    )> }
  )> }
);

export type PathwayAccessGroupFragment = (
  { __typename?: 'GroupModel' }
  & Pick<PrivateSchemaTypes.GroupModel, 'id' | 'name' | 'usersCount'>
);

export type PathwayAccessUsersQueryVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  offset?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['NonNegativeInt']>;
  limit?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['NonNegativeInt']>;
  order?: PrivateSchemaTypes.Maybe<Array<PrivateSchemaTypes.OrderDescriptor> | PrivateSchemaTypes.OrderDescriptor>;
  filters?: PrivateSchemaTypes.Maybe<Array<PrivateSchemaTypes.UserModelFilterInput> | PrivateSchemaTypes.UserModelFilterInput>;
}>;


export type PathwayAccessUsersQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { pathway?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'PathwayModelAsAdmin' }
      & PathwayAccessUsersFragment
    )> }
  )> }
);

export type PathwayAccessUsersFragment = (
  { __typename?: 'PathwayModelAsAdmin' }
  & Pick<PrivateSchemaTypes.PathwayModelAsAdmin, 'id' | 'usersCount'>
  & { usersCountWithoutFilter: PrivateSchemaTypes.PathwayModelAsAdmin['usersCount'] }
  & { users: Array<(
    { __typename?: 'UserModel' }
    & Pick<PrivateSchemaTypes.UserModel, 'id' | 'display_name' | 'userIdentity' | 'image_url' | 'email' | 'profile_img_url'>
    & { currentPathwayEnrolment?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'PathwayEnrolmentModel' }
      & Pick<PrivateSchemaTypes.PathwayEnrolmentModel, 'id' | 'certification_id'>
    )> }
  )> }
);

export type PathwayPatchMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  input: PrivateSchemaTypes.PathwayInput;
}>;


export type PathwayPatchMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { pathway?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'PathwayModelAsAdmin' }
      & Pick<PrivateSchemaTypes.PathwayModelAsAdmin, 'id'>
      & { patch?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'PathwayModelAsAdmin' }
        & Pick<PrivateSchemaTypes.PathwayModelAsAdmin, 'id' | 'title' | 'description' | 'state' | 'progress' | 'is_public' | 'published_date' | 'allow_comments'>
        & { coverImage?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'DocumentModel' }
          & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
        )>, tags: Array<(
          { __typename?: 'TagModel' }
          & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
        )> }
      )> }
    )> }
  )> }
);

export type PathwayDetailFieldsForManageFragment = (
  { __typename?: 'PathwayModelAsAdmin' }
  & Pick<PrivateSchemaTypes.PathwayModelAsAdmin, 'id' | 'title' | 'description' | 'state' | 'progress' | 'is_public' | 'updated_at' | 'published_date' | 'allow_comments' | 'currentTopicVersionsCount'>
  & { coverImage?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'DocumentModel' }
    & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
  )>, coverImageVariants: Array<(
    { __typename?: 'ImageVariantModel' }
    & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl' | 'size_key'>
  )>, tags: Array<(
    { __typename?: 'TagModel' }
    & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
  )>, currentPathwayVersion: (
    { __typename?: 'PathwayVersionModel' }
    & Pick<PrivateSchemaTypes.PathwayVersionModel, 'id' | 'version'>
  ), currentTopicVersions: Array<(
    { __typename?: 'TopicVersionModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicVersionModelAsEditor, 'id' | 'title'>
    & { topic: (
      { __typename?: 'TopicModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
      & { author: (
        { __typename?: 'UserModelPublicBase' }
        & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name' | 'userIdentity' | 'image_url'>
      ), workspace?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'WorkspaceModelAsCollaborator' }
        & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'id' | 'name' | 'is_open'>
      )> }
    ) }
  )> }
);

export type PathwayRelatedInstancesFragment = (
  { __typename?: 'PathwayModelAsAdmin' }
  & { relatedCampaignsByFilters: Array<(
    { __typename?: 'CampaignModelAsAdminMutations' }
    & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id' | 'name'>
    & { author?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserModel' }
      & Pick<PrivateSchemaTypes.UserModel, 'id' | 'userIdentity'>
    )> }
  )>, relatedCampaignsByActions: Array<(
    { __typename?: 'CampaignModelAsAdminMutations' }
    & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id' | 'name'>
    & { author?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserModel' }
      & Pick<PrivateSchemaTypes.UserModel, 'id' | 'userIdentity'>
    )> }
  )>, relatedCertifications: Array<(
    { __typename?: 'CertificationModelAsAdmin' }
    & Pick<PrivateSchemaTypes.CertificationModelAsAdmin, 'id' | 'name'>
    & { author?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserModel' }
      & Pick<PrivateSchemaTypes.UserModel, 'id' | 'userIdentity'>
    )> }
  )> }
);

export type PathwayRelatedInstancesQueryVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type PathwayRelatedInstancesQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { pathway?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'PathwayModelAsAdmin' }
      & PathwayRelatedInstancesFragment
    )> }
  )> }
);

export type PathwayWithTopicsQueryVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type PathwayWithTopicsQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { pathway?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'PathwayModelAsAdmin' }
      & PathwayDetailFieldsForManageFragment
    )> }
  )> }
);

export type PathwayTopicsUpdateOrderMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  topicIds: Array<PrivateSchemaTypes.Scalars['PositiveInt']> | PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type PathwayTopicsUpdateOrderMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { pathway?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'PathwayModelAsAdmin' }
      & Pick<PrivateSchemaTypes.PathwayModelAsAdmin, 'id'>
      & { updateTopicsOrder?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'PathwayModelAsAdmin' }
        & PathwayDetailFieldsForManageFragment
      )> }
    )> }
  )> }
);

export const PathwayAccessGroupFragmentDoc = gql`
    fragment pathwayAccessGroup on GroupModel {
  id
  name
  usersCount
}
    `;
export const PathwayAccessUsersFragmentDoc = gql`
    fragment pathwayAccessUsers on PathwayModelAsAdmin {
  id
  users(order: $order, offset: $offset, limit: $limit, filters: $filters) {
    id
    display_name
    userIdentity
    image_url
    email
    profile_img_url
    currentPathwayEnrolment(pathwayId: $id) {
      id
      certification_id
    }
  }
  usersCount(filters: $filters)
  usersCountWithoutFilter: usersCount
}
    `;
export const PathwayDetailFieldsForManageFragmentDoc = gql`
    fragment PathwayDetailFieldsForManage on PathwayModelAsAdmin {
  id
  title
  description
  state
  progress
  is_public
  updated_at
  published_date
  allow_comments
  coverImage {
    id
    cdnUrl
  }
  coverImageVariants {
    cdnUrl
    size_key
  }
  tags {
    id
    name
  }
  currentPathwayVersion {
    id
    version
  }
  currentTopicVersions {
    ... on TopicVersionModelAsEditor {
      id
      title
      topic {
        id
        author {
          id
          display_name
          userIdentity
          image_url
        }
        workspace {
          id
          name
          is_open
        }
      }
    }
  }
  currentTopicVersionsCount
}
    `;
export const PathwayRelatedInstancesFragmentDoc = gql`
    fragment PathwayRelatedInstances on PathwayModelAsAdmin {
  relatedCampaignsByFilters {
    id
    name
    author {
      id
      userIdentity
    }
  }
  relatedCampaignsByActions {
    id
    name
    author {
      id
      userIdentity
    }
  }
  relatedCertifications {
    id
    name
    author {
      id
      userIdentity
    }
  }
}
    `;
export const PathwayAccessGroupsDocument = gql`
    query pathwayAccessGroups($id: PositiveInt!, $order: [OrderDescriptor!]) {
  admin {
    pathway(id: $id) {
      id
      groups(order: $order) {
        ...pathwayAccessGroup
      }
    }
  }
}
    ${PathwayAccessGroupFragmentDoc}`;

/**
 * __usePathwayAccessGroupsQuery__
 *
 * To run a query within a React component, call `usePathwayAccessGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathwayAccessGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathwayAccessGroupsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePathwayAccessGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PathwayAccessGroupsQuery, PathwayAccessGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PathwayAccessGroupsQuery, PathwayAccessGroupsQueryVariables>(PathwayAccessGroupsDocument, options);
      }
export function usePathwayAccessGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PathwayAccessGroupsQuery, PathwayAccessGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PathwayAccessGroupsQuery, PathwayAccessGroupsQueryVariables>(PathwayAccessGroupsDocument, options);
        }
export type PathwayAccessGroupsQueryHookResult = ReturnType<typeof usePathwayAccessGroupsQuery>;
export type PathwayAccessGroupsLazyQueryHookResult = ReturnType<typeof usePathwayAccessGroupsLazyQuery>;
export type PathwayAccessGroupsQueryResult = Apollo.QueryResult<PathwayAccessGroupsQuery, PathwayAccessGroupsQueryVariables>;
export const PathwayAccessUsersDocument = gql`
    query pathwayAccessUsers($id: PositiveInt!, $offset: NonNegativeInt, $limit: NonNegativeInt, $order: [OrderDescriptor!], $filters: [UserModelFilterInput!]) {
  admin {
    pathway(id: $id) {
      ...pathwayAccessUsers
    }
  }
}
    ${PathwayAccessUsersFragmentDoc}`;

/**
 * __usePathwayAccessUsersQuery__
 *
 * To run a query within a React component, call `usePathwayAccessUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathwayAccessUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathwayAccessUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePathwayAccessUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PathwayAccessUsersQuery, PathwayAccessUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PathwayAccessUsersQuery, PathwayAccessUsersQueryVariables>(PathwayAccessUsersDocument, options);
      }
export function usePathwayAccessUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PathwayAccessUsersQuery, PathwayAccessUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PathwayAccessUsersQuery, PathwayAccessUsersQueryVariables>(PathwayAccessUsersDocument, options);
        }
export type PathwayAccessUsersQueryHookResult = ReturnType<typeof usePathwayAccessUsersQuery>;
export type PathwayAccessUsersLazyQueryHookResult = ReturnType<typeof usePathwayAccessUsersLazyQuery>;
export type PathwayAccessUsersQueryResult = Apollo.QueryResult<PathwayAccessUsersQuery, PathwayAccessUsersQueryVariables>;
export const PathwayPatchDocument = gql`
    mutation pathwayPatch($id: PositiveInt!, $input: PathwayInput!) {
  admin {
    pathway(id: $id) {
      id
      patch(input: $input) {
        id
        title
        description
        state
        progress
        is_public
        published_date
        allow_comments
        coverImage {
          id
          cdnUrl
        }
        tags {
          id
          name
        }
      }
    }
  }
}
    `;
export type PathwayPatchMutationFn = Apollo.MutationFunction<PathwayPatchMutation, PathwayPatchMutationVariables>;

/**
 * __usePathwayPatchMutation__
 *
 * To run a mutation, you first call `usePathwayPatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePathwayPatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pathwayPatchMutation, { data, loading, error }] = usePathwayPatchMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePathwayPatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PathwayPatchMutation, PathwayPatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PathwayPatchMutation, PathwayPatchMutationVariables>(PathwayPatchDocument, options);
      }
export type PathwayPatchMutationHookResult = ReturnType<typeof usePathwayPatchMutation>;
export type PathwayPatchMutationResult = Apollo.MutationResult<PathwayPatchMutation>;
export type PathwayPatchMutationOptions = Apollo.BaseMutationOptions<PathwayPatchMutation, PathwayPatchMutationVariables>;
export const PathwayRelatedInstancesDocument = gql`
    query pathwayRelatedInstances($id: PositiveInt!) {
  admin {
    pathway(id: $id) {
      ...PathwayRelatedInstances
    }
  }
}
    ${PathwayRelatedInstancesFragmentDoc}`;

/**
 * __usePathwayRelatedInstancesQuery__
 *
 * To run a query within a React component, call `usePathwayRelatedInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathwayRelatedInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathwayRelatedInstancesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePathwayRelatedInstancesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PathwayRelatedInstancesQuery, PathwayRelatedInstancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PathwayRelatedInstancesQuery, PathwayRelatedInstancesQueryVariables>(PathwayRelatedInstancesDocument, options);
      }
export function usePathwayRelatedInstancesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PathwayRelatedInstancesQuery, PathwayRelatedInstancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PathwayRelatedInstancesQuery, PathwayRelatedInstancesQueryVariables>(PathwayRelatedInstancesDocument, options);
        }
export type PathwayRelatedInstancesQueryHookResult = ReturnType<typeof usePathwayRelatedInstancesQuery>;
export type PathwayRelatedInstancesLazyQueryHookResult = ReturnType<typeof usePathwayRelatedInstancesLazyQuery>;
export type PathwayRelatedInstancesQueryResult = Apollo.QueryResult<PathwayRelatedInstancesQuery, PathwayRelatedInstancesQueryVariables>;
export const PathwayWithTopicsDocument = gql`
    query pathwayWithTopics($id: PositiveInt!) {
  admin {
    pathway(id: $id) {
      ...PathwayDetailFieldsForManage
    }
  }
}
    ${PathwayDetailFieldsForManageFragmentDoc}`;

/**
 * __usePathwayWithTopicsQuery__
 *
 * To run a query within a React component, call `usePathwayWithTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathwayWithTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathwayWithTopicsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePathwayWithTopicsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PathwayWithTopicsQuery, PathwayWithTopicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PathwayWithTopicsQuery, PathwayWithTopicsQueryVariables>(PathwayWithTopicsDocument, options);
      }
export function usePathwayWithTopicsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PathwayWithTopicsQuery, PathwayWithTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PathwayWithTopicsQuery, PathwayWithTopicsQueryVariables>(PathwayWithTopicsDocument, options);
        }
export type PathwayWithTopicsQueryHookResult = ReturnType<typeof usePathwayWithTopicsQuery>;
export type PathwayWithTopicsLazyQueryHookResult = ReturnType<typeof usePathwayWithTopicsLazyQuery>;
export type PathwayWithTopicsQueryResult = Apollo.QueryResult<PathwayWithTopicsQuery, PathwayWithTopicsQueryVariables>;
export const PathwayTopicsUpdateOrderDocument = gql`
    mutation pathwayTopicsUpdateOrder($id: PositiveInt!, $topicIds: [PositiveInt!]!) {
  admin {
    pathway(id: $id) {
      id
      updateTopicsOrder(topicIds: $topicIds) {
        ...PathwayDetailFieldsForManage
      }
    }
  }
}
    ${PathwayDetailFieldsForManageFragmentDoc}`;
export type PathwayTopicsUpdateOrderMutationFn = Apollo.MutationFunction<PathwayTopicsUpdateOrderMutation, PathwayTopicsUpdateOrderMutationVariables>;

/**
 * __usePathwayTopicsUpdateOrderMutation__
 *
 * To run a mutation, you first call `usePathwayTopicsUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePathwayTopicsUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pathwayTopicsUpdateOrderMutation, { data, loading, error }] = usePathwayTopicsUpdateOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      topicIds: // value for 'topicIds'
 *   },
 * });
 */
export function usePathwayTopicsUpdateOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PathwayTopicsUpdateOrderMutation, PathwayTopicsUpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PathwayTopicsUpdateOrderMutation, PathwayTopicsUpdateOrderMutationVariables>(PathwayTopicsUpdateOrderDocument, options);
      }
export type PathwayTopicsUpdateOrderMutationHookResult = ReturnType<typeof usePathwayTopicsUpdateOrderMutation>;
export type PathwayTopicsUpdateOrderMutationResult = Apollo.MutationResult<PathwayTopicsUpdateOrderMutation>;
export type PathwayTopicsUpdateOrderMutationOptions = Apollo.BaseMutationOptions<PathwayTopicsUpdateOrderMutation, PathwayTopicsUpdateOrderMutationVariables>;